'use client';

import { useEffect } from 'react';

/**
 * Registers the offline-support service worker on the client only.
 * Must run after mount so it never blocks the initial render or SSR.
 */
export default function ServiceWorkerRegister() {
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    const register = () => {
      navigator.serviceWorker.register('/sw.js').catch(() => {});
    };

    window.addEventListener('load', register);
    return () => window.removeEventListener('load', register);
  }, []);

  return null;
}
